import { Controller } from "@hotwired/stimulus"

/**
 * Confirm Delete Controller
 *
 * A reusable in-place confirmation pattern for delete actions.
 * Shows a "Delete" button that, when clicked, reveals an "Are you sure?"
 * confirmation with "Delete" and "Cancel" buttons.
 *
 * Usage:
 *   <div data-controller="confirm-delete">
 *     <!-- Initial state: just the trigger button -->
 *     <button data-confirm-delete-target="trigger" data-action="confirm-delete#show">
 *       Delete
 *     </button>
 *
 *     <!-- Confirmation state: hidden by default -->
 *     <div data-confirm-delete-target="confirmation" class="hidden">
 *       <span>Are you sure?</span>
 *       <button data-action="confirm-delete#cancel">Cancel</button>
 *       <form method="post" action="/delete/path" data-turbo-method="delete">
 *         <button type="submit">Delete</button>
 *       </form>
 *     </div>
 *   </div>
 *
 * Or use the shared partial: render 'shared/confirm_delete', path: delete_path
 */
export default class extends Controller {
  static targets = ["trigger", "confirmation"]

  show(event) {
    event.preventDefault()
    event.stopPropagation()
    this.triggerTarget.classList.add("hidden")
    this.confirmationTarget.classList.remove("hidden")
  }

  cancel(event) {
    event.preventDefault()
    event.stopPropagation()
    this.confirmationTarget.classList.add("hidden")
    this.triggerTarget.classList.remove("hidden")
  }

  // Auto-hide confirmation if user clicks outside
  clickOutside(event) {
    if (!this.element.contains(event.target)) {
      this.cancel(event)
    }
  }

  connect() {
    // Optional: close on click outside
    this.boundClickOutside = this.clickOutside.bind(this)
  }

  disconnect() {
    document.removeEventListener("click", this.boundClickOutside)
  }
}
